<div class="alert-wrapper">
  <div mat-dialog-content>{{ data }}</div>
  <div mat-dialog-actions>
    <button class="btn btn-primary" mat-button mat-dialog-close>Close</button>
  </div>
</div>
